export const ENDPOINTS = {
  getHotels: '/gateway/admin/hotels',
  getEditosHotels: '/gateway/admin/hotels/editos',
  getHotelInfo: '/gateway/admin/hotels/:id',
  getExperiencesByHotelId: '/gateway/admin/hotels/:id/experiences',
  getRoomsByHotelId: '/gateway/admin/hotels/:id/rooms',
  getHotelDiscover: '/gateway/admin/hotels/:id/discover',
  saveHotelDiscover: '/gateway/admin/hotels/:id/discover',
  publishHotel: '/gateway/admin/hotels/:id/publish',
  unpublishHotel: '/gateway/admin/hotels/:id/unpublish',
  hideHotel: '/gateway/admin/hotels/:id/hide',
  updateCopywriting: '/gateway/admin/hotels/:id/copywriting',
  getHotelEntities: '/gateway/admin/hotels/:id/entities',
  getHotelGallery: '/gateway/admin/hotels/:id/gallery',
  sortHotelEntities: '/gateway/admin/hotels/:id/sort-entities',
  migrateHotel: '/gateway/admin/hotels/:id/migrate-to-ndm',
  getHotelContacts: '/gateway/admin/hotels/:id/contacts',
  updateHotelContacts: '/gateway/admin/hotels/:id/contacts',
  updateDayRoomAccess: '/gateway/hotels/:id/day-room-access',
} as const;

export const CORE_QUERY_KEYS = {
  hotels: 'admin-hotels',
  experiences: 'admin-experiences',
  rooms: 'admin-rooms',
  hotel: 'admin-hotel',
  hotelInfo: 'admin-hotel-info',
  hotelEntities: 'admin-hotel-entities',
  hotelGallery: 'admin-hotel-gallery',
  editoHotels: 'admin-edito-hotels',
  hotelContacts: 'admin-hotel-contacts',
} as const;
